interface HTMLCollection {
    forEach(callbackfn: (value: any, index: number, array: any[]) => void, thisArg?: any): void;
}

if (window.HTMLCollection && !HTMLCollection.prototype.forEach) {
    HTMLCollection.prototype.forEach = Array.prototype.forEach;
}
